import { Modal, ModalContent, ModalHeader, ModalTitle } from '../ui/modal';
import { Card, CardContent } from '../ui/card';
import { GoogleIcon, KakaoIcon } from '../ui/icons';

interface LoginRequireModalProps {
  isOpenLoginModal: boolean;
  onCloseLoginRequireModal: () => void;
}

/**
 * 로그인 요청 모달
 *
 * @author hjkim
 * @constructor
 */
const LoginRequireModal = ({ isOpenLoginModal, onCloseLoginRequireModal }: LoginRequireModalProps) => {
  /* 로그인 버튼 handler */
  const onSignInHandler = (provider: string) => {
    console.log('로그인 시도:', provider);
    const baseUrl = process.env.REACT_APP_API_URL;
    if (provider === 'kakao') {
      window.location.href = `${baseUrl}/oauth2/authorization/${provider}`;
    } else if (provider === 'google') {
      window.location.href = `${baseUrl}/oauth2/authorization/google`;
    }
  };
  return (
    <Modal isOpen={isOpenLoginModal} onClose={onCloseLoginRequireModal}>
      <ModalHeader>
        <ModalTitle>로그인 필요</ModalTitle>
      </ModalHeader>
      <ModalContent className="">
        <div className="mb-2">
          <p className="p-2">
            이 설문에 투표하려면 로그인이 필요합니다. <br />
            로그인 후 다시 시도해 주세요.
          </p>
        </div>
        <Card className="p-2 border-t shadow-xl">
          <CardContent className="space-y-4">
            <div className="mb-6" />
            <div className="flex flex-col items-center space-y-3">
              <button
                type="button"
                onClick={() => onSignInHandler('kakao')}
                className="w-full h-14 bg-[#FEE500] hover:bg-[#FDD835] border border-[#FDD835] rounded-xl font-semibold text-black transition-all duration-200 flex items-center justify-center gap-3 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                <KakaoIcon />
                <span>카카오 계정으로 계속하기</span>
              </button>
              <button
                type="button"
                onClick={() => onSignInHandler('google')}
                className="w-full h-14 bg-white hover:bg-gray-50 border border-gray-300 rounded-xl font-semibold text-black transition-all duration-200 flex items-center justify-center gap-3 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                <GoogleIcon />
                <span>구글 계정으로 계속하기</span>
              </button>
            </div>
          </CardContent>
        </Card>
      </ModalContent>
    </Modal>
  );
};
export default LoginRequireModal;
